import React from "react";
import { Link } from "react-router-dom";
import { Helmet, HelmetProvider } from "react-helmet-async";
import "../../styles/ERprotocols.css";
import "../../styles/AirStacking.css";
const AirStacking = () => {
  return (
    <div className="air-container">
      {" "}
      <HelmetProvider>
        <Helmet>
          <title>Air Stacking - Glossopharyngeal Breathing (GPB)</title>

          <meta
            name="description"
            content="Glossopharyngeal Breathing (GPB), or air stacking, helps individuals with weak inspiratory muscles breathe independently without a ventilator. Learn how GPB works, training methods, and its advantages over tracheostomy."
          />
          <meta
            name="keywords"
            content="Glossopharyngeal Breathing, GPB, air stacking, respiratory support, inspiratory muscle weakness, noninvasive ventilation, tracheostomy alternative, breathing technique, ventilator backup"
          />
          <meta name="author" content="Your Organization or Author Name" />
          <meta name="viewport" content="width=device-width, initial-scale=1" />
          <meta
            property="og:image"
            content="https://doctorbach.com/images/BachJohn.jpg"
          />
          <meta
            property="og:image"
            content="https://doctorbach.com/favicon.png"
          />
          <meta
            property="og:url"
            content="https://doctorbach.com/resources/as"
          />
          <meta property="og:type" content="article" />
        </Helmet>
      </HelmetProvider>
      <div className="precautions">
        <div className="er-pro">
          <h3>Air Stacking - Glossopharyngeal Breathing (GPB)</h3>
          <p>
            Both inspiratory and, indirectly, expiratory muscle function can be
            assisted by "air stacking", technically known as "glossopharyngeal
            breathing" (GPB). For individuals with weak inspiratory muscles and
            no ability to breathe on their own, GPB can provide normal lung
            ventilation and perfect safety throughout the day without using a
            ventilator or in the event of sudden ventilator failure day or
            night.
          </p>
          <p>
            The technique involves the use of the glottis (throat) to add to an
            inspiratory effort by projecting (gulping) boluses of air into the
            lungs. The glottis closes with each "gulp". One breath usually
            consists of 6 to 9 gulps of 40 to 200 ml each. During the training
            period the efficiency of GPB can be monitored by spirometrically
            measuring the milliliters of air per gulp, gulps per breath, and
            breaths per minute. A training manual and numerous videos are
            available.
          </p>{" "}
          <p>
            GPB is rarely useful in the presence of an indwelling tracheostomy
            tube. It cannot be used when the tube is uncapped as it is during
            tracheostomy IPPV, and even when capped, the gulped air tends to
            leak around the outer walls of the tube and out the stoma as airway
            volumes and pressures increase during the GPB air stacking process.
            The safety and versatility afforded by GPB are key reasons to
            eliminate tracheostomy in favor of noninvasive aids.
          </p>
        </div>
        <div className="er-pro">
          <h4>Additional information</h4>

          <p>
            For more information, click here for{" "}
            <Link
              to="/resources/op"
              style={{ textDecoration: "none", color: "darkblue" }}
            >
              Outpatient protocols{" "}
            </Link>
            and{" "}
            <Link
              to="/resources/icu"
              style={{ textDecoration: "none", color: "darkblue" }}
            >
              Intensive Care Protocols.
            </Link>{" "}
          </p>
          <p>
            For more information about emergency room precautions,{" "}
            <Link
              to="/resources/er"
              style={{ textDecoration: "none", color: "darkblue" }}
            >
              click here.
            </Link>{" "}
          </p>
        </div>
      </div>
    </div>
  );
};

export default AirStacking;
